import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import { ReportInvoices } from 'api';
const { add, adoptMatches } = ReportInvoices();
const styles = theme => ({
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  select: {
    marginBottom: '4px',
    minWidth: '100px',
    width: '50%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const DialogConfirmInvoiceSplit = ({ open, onClose, onCreated, meta, setIsDialogOpen, ...props }) => {
  const { classes } = props;
  const { mutate: createInvoice } = useMutation(
    ({ dsp_name, native_currency_abbv }) => add(dsp_name, native_currency_abbv),
    {
      onSuccess: async created => {
        await splitMatchesToNewInvoice({ newInvoiceId: created.id, matchIds: meta.matchIds });
      },
      onError: _e => {
        alert(_e);
        onCreated(false);
      },
    }
  );

  const { mutate: splitMatchesToNewInvoice } = useMutation(
    ({ newInvoiceId, matchIds }) => adoptMatches(newInvoiceId, matchIds),
    {
      onSuccess: () => onCreated(true),
      onError: () => onCreated(false),
    }
  );

  // Data
  const formMethods = useForm();

  const handleFormSubmit = async () => {
    await createInvoice({ dsp_name: meta.dsp_name, native_currency_abbv: meta.native_currency_abbv });
  };

  return (
    <MuiDialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Split Invoice</MuiDialogTitle>
      <form onSubmit={formMethods.handleSubmit(handleFormSubmit)}>
        <MuiDialogContent>Split selected matches to new invoice?</MuiDialogContent>
        <MuiDialogActions className={classes.dialogFooter}>
          <MuiButton variant="contained" onClick={onClose}>
            Cancel
          </MuiButton>
          <MuiButton variant="contained" color="primary" type="submit">
            Split
          </MuiButton>
        </MuiDialogActions>
      </form>
    </MuiDialog>
  );
};

export default withStyles(styles)(DialogConfirmInvoiceSplit);
